import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import FamilyAgency from "../components/FamilyAgency";
import BannerFamilyTravel from "../components/BannerfamilyTravel";
import FamilyContact from "../components/FamilyContact";
import PlanningTrip from "../components/PlanningTrip";
import Clients from "../components/Clients";
import Footer from "../components/Footer";
import { fetchData } from "../services/api";


interface PlanningTripData {
  text: string;
  description: string;
}

interface bannersData {
  bannerText: string;
  subText: string;
  bannerVideo: string;
}

interface MetaData {
  metaKeyword: string;
  metaDescription: string;
  metaTitle: string;
}

const FamilyTravel: React.FC = () => {
  const [planningTripData, setPlanningTripData] = useState<PlanningTripData>({
    text: "",
    description: "",
  });

  const [metaData, setMetaData] = useState<MetaData>({
    metaKeyword: "",
    metaDescription: "",
    metaTitle: "",
  });

  const [bannerData, setBannerData] = useState<bannersData>({
    bannerText: "",
    subText: "",
    bannerVideo: "",
  });

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const response = await fetchData<{
          meta_title: string;
          meta_keyword: string;
          meta_description: string;
          whereTo: PlanningTripData[];
          banners: bannersData[];
        }>({
          url: "pages/get",
          data: { pageId: 2 },
        });

        const data = response?.data;

        if (data) {
          setMetaData({
            metaTitle: data.meta_title,
            metaKeyword: data.meta_keyword,
            metaDescription: data.meta_description,
          });

          if (data.whereTo?.length > 0) {
            setPlanningTripData(data.whereTo[0]);
          }

          if (data.banners?.length > 0) {
            console.log("Banner Data:", data.banners[0]);
            setBannerData(data.banners[0]);
          }
        } else {
          throw new Error("No data found.");
        }
      } catch (error) {
        console.error("Failed to fetch page data:", error);
        setError("Failed to load page data.");
      }
    };

    fetchPageData();
  }, []);

  return (
    <div>
      <Helmet>
        <title>{metaData.metaTitle}</title>
        <meta name="keywords" content={metaData.metaKeyword} />
        <meta name="description" content={metaData.metaDescription} />
        <meta name="title" content={metaData.metaTitle} />
        <link rel="canonical" href="https://travelnrelax.com/family-travel/" />
      </Helmet>

      {bannerData.bannerText && (
        <Navbar
          heading={bannerData.bannerText}
          subHeading={bannerData.subText}
          video={bannerData.bannerVideo}
        />
      )}

      <FamilyAgency />
      <BannerFamilyTravel />
      <FamilyContact />

      {error ? (
        <p className="text-red-600 text-center py-4">{error}</p>
      ) : (
        <PlanningTrip
          headingplanning={
            planningTripData.text || "Let's Plan Your Perfect Family Trip"
          }
          paragraph={
            planningTripData.description ||
            "We'll help craft unforgettable family travel experiences."
          }
        />
      )}

      <Clients />
      <Footer />
    </div>
  );
};

export default FamilyTravel;
